<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="importDialog.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="50%"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="120px"
    >
      <el-row :gutter="12">
        <el-col>
          <el-form-item>
            <butn btntype="primary" title="下载模板" @click="downloadTemplate"></butn>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            required
            label="附件："
            error="请上传附件"
            :show-message="file == null"
          >
            <upload v-model="file" :accepts="['excel']" ref="removeFile"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Upload from "@/components/upload/excel";
import { liveExportUserTemplate } from "@/assets/excel/index.js";
import { 
  ticketUserRangeImport,
  ticketUserLimitImport
 } from "@/api/resourceService";
import { downloadByUrl } from "../../../../utils/common";

export default {
  components: { butn, Upload },
  props: {
    importDialog: {
      type: Object,
      default: () => {
        return {
          show: false
        };
      },
    },
    uuid: {
      type: String,
      default: () => ""
    },
    // 1表示线上线下导入
    type: {
      type: Number,
      default: 1,
    },
    // 用于线上，线下区分
    bizType: {
      type: Number,
      default: 1,
    },
    ticketId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      EXCP: liveExportUserTemplate,
      rules: {},
      curdTitle: "用户导入",
      file: null,
      curdForm: {},
    };
  },
  created() {},
  methods: {
    //提交数据
    createData() {
      if (this.file != null) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        if (this.type == 1) {
          // 线上，线下预约范围导入
          formData.append("ticketId", this.ticketId);
          formData.append("bizType", this.bizType);
          formData.append("ticketDetailId", this.uuid);
          ticketUserRangeImport(formData).then((res) => {
            this.loading = false;
            if (res && res.code == 0) {
              if (res.data == null) {
                this.$message.success(res.msg);
                this.$emit("closeDialog", true);
              } else {
                this.$message.error("导入包含错误数据，请检查");
                this.$router.push({
                  path: "/excelError",
                });
                localStorage.setItem("errorExcelData", JSON.stringify(res.data));
              }
            } else {
              this.$refs.removeFile.$refs.upload.uploadFiles.pop();
              this.file = null;
            }
          });
        } else if (this.type == 4) {
          // 限制预约范围导入
          formData.append("ticketId", this.uuid);
          ticketUserLimitImport(formData).then((res) => {
            this.loading = false;
            if (res && res.code == 0) {
              if (res.data == null) {
                this.$message.success(res.msg);
                this.$emit("closeDialog", true);
              } else {
                this.$message.error("导入包含错误数据，请检查");
                this.$router.push({
                  path: "/excelError",
                });
                localStorage.setItem("errorExcelData", JSON.stringify(res.data));
              }
            } else {
              this.$refs.removeFile.$refs.upload.uploadFiles.pop();
              this.file = null;
            }
          });
        }
        
      }
    },
    closeDialog() {
      // 点击取消 数据重置
      this.file = null;
      this.$emit("closeDialog", false);
    },
    downloadTemplate() {
      downloadByUrl("", this.EXCP);
    }
  }
};
</script>

<style lang="scss" scoped></style>
